/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-masonry.html";
import "../../ns-button/ns-button.js";
import "../../ns-social-share/ns-social-share.js";
import "../ns-brick/ns-brick.js";
import "../../assets/videoPlay.png";
import "@polymer/paper-dialog/paper-dialog.js";
import vpr from "../../assets/vpr.png";
import { events } from "@nuskin/ns-util";

export class NsMasonry extends PolymerElement {
  constructor() {
    super();
  }
  static get is() {
    return "ns-masonry";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      share: {
        type: String,
        value: "share"
      },
      index: String,
      current: Object,
      distributorId: String,
      businessName: String,
      englishName: String,
      nativeName: String,
      country: String,
      profilePhoto: String,
      vidSrc: String,
      badges: Array,
      videoPlaying: {
        type: Boolean,
        value: false
      },
      hasVideoOnly: {
        type: Boolean,
        value: false
      },
      isEnglishName: {
        type: Boolean,
        value: true
      },
      vprURL: {
        type: String,
        value: vpr
      },
      hasPicture: {
        type: Boolean,
        value: true
      },
      hasVideo: {
        type: Boolean,
        value: false
      },
      hasMedia: {
        type: Boolean,
        value: true
      },
      englishText: {
        type: String,
        value: "english"
      },
      nativeText: {
        type: String,
        value: "local"
      },
      active: {
        type: String,
        value: "inactive"
      },
      singleProfile: {
        type: Object,
        value: {},
        observer: "_singleProfileUpdated"
      },
      pagination: {
        type: Number,
        notify: true
      },
      c1Objects: {
        type: Array,
        value: []
      },
      c2Objects: {
        type: Array,
        value: []
      },
      c3Objects: {
        type: Array,
        value: []
      },
      c4Objects: {
        type: Array,
        value: []
      },
      twoColFirstObjects: {
        type: Array,
        value: []
      },
      twoColSecondObjects: {
        type: Array,
        value: []
      },
      masonryObjects: {
        type: Array,
        value: [{}],
        observer: "_masonryChanged"
      },
      gotAllData: {
        type: Boolean,
        notify: true
      },
      currentlySearching: {
        type: String,
        notify: true,
        value: "false"
      }
    };
  }

  ready() {
    super.ready();
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("scroll", () => {
      if (
        Math.ceil(window.innerHeight + window.pageYOffset) >=
        document.body.offsetHeight
      ) {
        // only increment pagination if there might be more data. if last query got no data then don't allow another query when scrolling down
        if (this.gotAllData === false && this.currentlySearching === "false") {
          this.pagination++;
        }
      }
    });
  }

  _singleProfileUpdated(newVal) {
    if (Object.keys(newVal).length != 0 && newVal.constructor === Object) {
      this.current = newVal;
      this._currentProfileChanged(this.current);
      this.businessName = this.current.businessName;
      this.englishName = this.current.englishName;
      if (this.current.nativeName && this.current.nativeName != "") {
        this.nativeName = this.current.nativeName;
      } else {
        this.nativeName = this.current.englishName;
      }
      this.country = this.current.country;
      this.distributorId = this.current.distributorId;
      this.badges = this.current.badges;
      this.profilePhoto = `https://www.nuskin.com/${this.current.profilePhoto}`;
      if (this.current.videos[0] && this.current.videos[0].length > 0) {
        this.vidSrc = `https://www.youtube.com/embed/${this.current.videos[0]}`;
        this.hasMedia = true;
        this.hasVideo = true;
        if (!this.hasPicture) {
          this.hasVideoOnly = true;
        }
      }
      if (!this.hasMedia) {
        this.$.badges.classList.add("no-media");
      } else if (this.$.badges.classList.contains("no-media")) {
        this.$.badges.classList.remove("no-media");
      }
      //Lock background from scrolling since modal is a fixed position.
      document.querySelector("body").style.cssText += "overflow: hidden;";
      //Open the modal
      this.$.modal.toggle();
    }
  }

  _masonryChanged() {
    this.c1Objects = [];
    this.c2Objects = [];
    this.c3Objects = [];
    this.c4Objects = [];
    this.twoColFirstObjects = [];
    this.twoColSecondObjects = [];
    for (let i = 0; i < this.masonryObjects.length; i++) {
      if (i % 4 == 0) {
        this.c1Objects = this.c1Objects.concat(this.masonryObjects[i]);
      }
      if (i % 4 == 1) {
        this.c2Objects = this.c2Objects.concat(this.masonryObjects[i]);
      }
      if (i % 4 == 2) {
        this.c3Objects = this.c3Objects.concat(this.masonryObjects[i]);
      }
      if (i % 4 == 3) {
        this.c4Objects = this.c4Objects.concat(this.masonryObjects[i]);
      }

      if (i % 2 == 0) {
        this.twoColFirstObjects = this.twoColFirstObjects.concat(
          this.masonryObjects[i]
        );
      }
      if (i % 2 == 1) {
        this.twoColSecondObjects = this.twoColSecondObjects.concat(
          this.masonryObjects[i]
        );
      }
    }
  }

  _videosArrayChanged(videos) {
    this.hasVideo = true;
    if (!this.hasMedia) {
      this.hasMedia = true;
    }
    if (!this.hasPicture) {
      this.hasVideoOnly = true;
    }
  }

  _badgesArrayChanged(badges) {}

  _currentProfileChanged(profile) {
    if (profile.videos[0] && profile.videos.length > 0) {
      this._videosArrayChanged(profile.videos);
    }
  }

  openModal(e) {
    this.index = e.currentTarget.id;
    this.current = this.masonryObjects[this.index];
    this._currentProfileChanged(this.current);
    this.businessName = this.current.businessName;
    this.englishName = this.current.englishName;
    if (this.current.nativeName && this.current.nativeName != "") {
      this.nativeName = this.current.nativeName;
    } else {
      this.nativeName = this.current.englishName;
    }
    this.country = this.current.country;
    this.distributorId = this.current.distributorId;
    this.badges = this.current.badges;
    this.profilePhoto = this.current.profilePhoto;
    if (this.current.videos[0] && this.current.videos[0].length > 0) {
      this.vidSrc = `https://www.youtube.com/embed/${this.current.videos[0]}`;
      this.hasMedia = true;
      this.hasVideo = true;
      if (!this.hasPicture) {
        this.hasVideoOnly = true;
      }
    }
    if (!this.hasMedia) {
      this.$.badges.classList.add("no-media");
    } else if (this.$.badges.classList.contains("no-media")) {
      this.$.badges.classList.remove("no-media");
    }
    //Lock background from scrolling since modal is a fixed position.
    document.querySelector("body").style.cssText += "overflow: hidden;";
    //Check for broken images
    this.checkMedia();
    //Open the modal
    this.$.modal.toggle();
    events.publish(events.recognition.PROFILED_VIEWED, {
      distributorID: this.distributorId,
      country: this.country,
      name: this.englishName
    });
  }

  toggleLang(e) {
    const id = e.currentTarget.id;
    const englishClass = this.$.english.classList;
    const nativeClass = this.$.native.classList;
    if (id === "english" && !this.isEnglishName) {
      //Perform Toggle
      this.isEnglishName = !this.isEnglishName;
      englishClass.add("active");
      nativeClass.remove("active");
    } else if (id === "native" && this.isEnglishName) {
      //Perform Toggle
      this.isEnglishName = !this.isEnglishName;
      nativeClass.add("active");
      englishClass.remove("active");
    }
  }

  closeModal() {
    document.querySelector("body").style.cssText += "overflow: scroll;";
    this.resetMedia();
    this.$.modal.close();
  }

  toggleVideo() {
    this.videoPlaying = !this.videoPlaying;
    //Force modal to close when stopping video
    if (!this.videoPlaying) {
      this.closeModal();
    }
  }

  checkMedia() {
    //check for null
    if (this.shadowRoot.querySelector("img")) {
      //check if img source is broken
      if (
        !this.shadowRoot.querySelector(".media").querySelector("img")
          .naturalWidth > 0
      ) {
        this.missingImg();
      } else {
        this.$.modal.center();
        this.shadowRoot
          .querySelector(".media")
          .querySelector("img")
          .addEventListener("load", () => {
            this.$.modal.center();
          });
      }
    } else {
      this.missingImg();
    }
  }

  resetMedia() {
    //Make sure all defaults are set
    const modal = this.$.modal;
    const badges = this.$.badges;
    //Force video to stop on exit.
    this.set("vidSrc", "");
    if (modal.classList.contains("no-media")) {
      modal.classList.remove("no-media");
    }
    if (badges.classList.contains("no-media")) {
      badges.classList.remove("no-media");
    }
    this.badges = [];
    this.set("hasMedia", true);
    this.set("hasPicture", true);
    this.hasVideo = false;
    this.hasVideoOnly = false;
    this.isEnglishName = true;
    if (this.$.native.classList.contains("active")) {
      this.$.native.classList.remove("active");
      this.$.english.classList.add("active");
    }
  }

  missingImg() {
    //Ran when image 404's rather then not being there from the beginning
    this.set("hasPicture", false);
    if (this.hasVideo) {
      this.set("hasVideoOnly", true);
    } else {
      this.set("hasMedia", false);
      this.$.badges.classList.add("no-media");
      this.$.modal.classList.add("no-media");
    }
  }

  toggleWall() {
    if (this.active === "active") {
      this.set("active", "inactive");
    } else {
      this.set("active", "active");
    }
  }

  printIndex(rowNumber, addThis, itemsInRow) {
    return rowNumber * itemsInRow + addThis;
  }
}

customElements.define(NsMasonry.is, NsMasonry);
